ion-footer {
  display: block;
  position: relative;
  order: 1;
  width: 100%;
  z-index: 10;
}

ion-footer.footer-toolbar-padding ion-toolbar:last-of-type {
  padding-bottom: var(--ion-safe-area-bottom, 0);
}

.footer-md {
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.footer-md.ion-no-border {
  box-shadow: none;
}